import toast from "react-hot-toast";
import ModalV2 from "../../../../components/ModalV2";
import useModal from "../../../../hooks/useModal";
import { useRef } from "react";
import QRCode from "react-qr-code";
import { Button } from "@oc-labs/wt-storybook";
import { ClipLoader } from "react-spinners";

export default function NFTQRModal() {
  const { modal } = useModal("nft-qr-modal");
  const qrCodeRef = useRef();

  const nft = modal?.props || null;

  const handleDownloadSvg = () => {
    const data = new XMLSerializer().serializeToString(qrCodeRef.current);
    const blob = new Blob([data], { type: "image/svg+xml" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${nft?.id}.svg`;
    link.click();
    URL.revokeObjectURL(url);
    toast.success("QR Code downloaded successfully");
  };

  const handleDownloadPng = async () => {
    const data = new XMLSerializer().serializeToString(qrCodeRef.current);
    const blob = new Blob([data], { type: "image/svg+xml" });
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      canvas.toBlob((blob) => {
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${nft?.id}.png`;
        link.click();
        URL.revokeObjectURL(url);
        toast.success("QR Code downloaded successfully");
      }, "image/png");
    };
    img.src = URL.createObjectURL(blob);
  };

  return (
    <ModalV2 name="nft-qr-modal">
      {nft ? (
        <>
          <div className="mb-4 flex justify-center">
            <QRCode value={nft?.url} ref={qrCodeRef} />
          </div>
          <div className="flex justify-center gap-4">
            <Button onClick={handleDownloadPng}>PNG</Button>

            <Button onClick={handleDownloadSvg}>SVG</Button>
          </div>
        </>
      ) : (
        <ClipLoader size={50} color="#4A90E2" />
      )}
    </ModalV2>
  );
}
